import { render, staticRenderFns } from "./PersonsTurnoversReportComponent.vue?vue&type=template&id=e2457f5c&"
import script from "./PersonsTurnoversReportComponent.vue?vue&type=script&lang=js&"
export * from "./PersonsTurnoversReportComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports